{
  "refinement-extensions.allApps": "Tüm uygulamalar",
  "refinement-extensions.management": "Uygulama ayarları",
  "refinement-extensions.deviceTracking.tab.devices": "Cihazlar",
  "refinement-extensions.deviceTracking.tab.usage": "Kullanım",
  "refinement-extensions.slot.music.practice": "Müzik Pratikleri",
  "refinement-extensions.slot.lessons.sessions": "Ders Oturumları",
  "refinement-extensions.slot.cycling.rides": "Bisiklet Sürüşleri",
  "refinement-extensions.slot.device_tracking.usage": "Uygulama Kullanım Özetleri",
  "refinement-extensions.role.music.instrument": "Enstrüman",
  "refinement-extensions.role.duration": "Süre",
  "refinement-extensions.role.music.assessment": "Değerlendirme",
  "refinement-extensions.role.lessons.course": "Kurs",
  "refinement-extensions.role.lessons.title": "Oturum",
  "refinement-extensions.role.lessons.transcript": "Ders Metni",
  "refinement-extensions.role.cycling.distance": "Mesafe",
  "refinement-extensions.role.cycling.comment": "Açıklama",
  "refinement-extensions.role.tracking.application": "Uygulama",
  "refinement-extensions.type.short_text": "Kısa metin",
  "refinement-extensions.type.long_text": "Uzun metin",
  "refinement-extensions.type.duration": "Süre",
  "refinement-extensions.type.measurement": "Ölçüm",
  "refinement-extensions.v2.open": "Yalnızca veri içeren paketleri keşfet",
  "refinement-extensions.v2.hide": "Veri paketlerini gizle",
  "refinement-extensions.v2.title": "Yalnızca veri içeren yetenek paketleri",
  "refinement-extensions.v2.description": "Çalıştırılabilir kod kurmadan bütünlüklü bir Yaşam düzeni ekleyin. Kurulumdan önce tüm yapılar, yetkiler ve değişmez sürüm incelenir.",
  "refinement-extensions.v2.author.open": "Paket belgesi ekle",
  "refinement-extensions.v2.author.close": "Paket düzenleyiciyi kapat",
  "refinement-extensions.v2.author.document": "Kapalı paket JSON belgesi",
  "refinement-extensions.v2.author.hint": "Yalnızca sınırlı Extensions v2 söz dizimi kabul edilir. Kod, HTML, prompt, ağ erişimi ve çalıştırılabilir ifadeler reddedilir.",
  "refinement-extensions.v2.author.assistant": "Bu taslak bir asistandan geldi",
  "refinement-extensions.v2.author.publish": "Doğrulamadan sonra bu değişmez sürümü yayımla",
  "refinement-extensions.v2.author.validate": "Güvenle doğrula",
  "refinement-extensions.v2.author.save": "Paket sürümünü kaydet",
  "refinement-extensions.v2.author.valid": "Geçerli değişmez parmak izi: {{fingerprint}}",
  "refinement-extensions.v2.provenance.assistant": "İncelenmiş asistan taslağı",
  "refinement-extensions.v2.provenance.owner": "Kullanıcı tarafından yazıldı",
  "refinement-extensions.v2.error.noUpgradeTarget": "Kullanılabilir bir yükseltme hedefi yok.",
  "refinement-extensions.v2.error.noUpgradePreview": "Uygulamadan önce yükseltmeyi önizleyin.",
  "refinement-extensions.v2.error.noRollbackReceipt": "Kullanılabilir bir geri alma makbuzu yok.",
  "refinement-extensions.v2.error.noUninstallPreview": "Uygulamadan önce kaldırma işlemini önizleyin.",
  "refinement-extensions.v2.error.validateFirst": "Önce paket belgesini doğrulayın.",
  "refinement-extensions.v2.loadError": "Yetenek paketleri yüklenemedi.",
  "refinement-extensions.v2.drafts": "Doğrulanmış paket taslakları",
  "refinement-extensions.v2.publishDraft": "Değişmez sürümü yayımla",
  "refinement-extensions.v2.updateAvailable": "Güncelleme var",
  "refinement-extensions.v2.installed": "Kurulu",
  "refinement-extensions.v2.available": "Kullanılabilir",
  "refinement-extensions.v2.parts": "parça",
  "refinement-extensions.v2.manage": "Yönet",
  "refinement-extensions.v2.review": "Kurulumu incele",
  "refinement-extensions.v2.empty": "Henüz veri paketi yok",
  "refinement-extensions.v2.emptyDescription": "Doğrulanmış bir paket belgesi ekleyin veya katalog paketleri hazır olduğunda geri dönün.",
  "refinement-extensions.v2.reviewDescription": "Hesabınızı değiştirmeden önce tam değişmez sürümü, yetkiyi ve yapıları inceleyin.",
  "refinement-extensions.v2.source": "Kaynak ve güven",
  "refinement-extensions.v2.sensitivity": "Hassasiyet",
  "refinement-extensions.v2.fingerprint": "Değişmez parmak izi",
  "refinement-extensions.v2.dataEgress": "Veri çıkışı",
  "refinement-extensions.v2.noEgress": "Yok",
  "refinement-extensions.v2.version": "Sürüm",
  "refinement-extensions.v2.structures": "Yapılar ve üstveri",
  "refinement-extensions.v2.capabilities": "Verilen yetenekler",
  "refinement-extensions.v2.scopes": "Verilen hesap kapsamları",
  "refinement-extensions.v2.preview": "Tam kurulumu önizle",
  "refinement-extensions.v2.previewReady": "İmzalı önizleme hazır",
  "refinement-extensions.v2.consent": "Bu parmak izini, yetkileri ve oluşturulacak ya da bağlanacak yapıları inceledim.",
  "refinement-extensions.v2.install": "Bu tam sürümü kur",
  "refinement-extensions.v2.activeExact": "{{version}} sürümü incelenmiş yetkileriyle etkin.",
  "refinement-extensions.v2.updateTitle": "Sürüm değişikliği",
  "refinement-extensions.v2.previewUpdate": "Uyumluluğu denetle",
  "refinement-extensions.v2.updateConsent": "Listelenen yetki ve veri değişikliklerini onaylıyorum.",
  "refinement-extensions.v2.applyUpdate": "Tam güncellemeyi uygula",
  "refinement-extensions.v2.rollback": "Geri al",
  "refinement-extensions.v2.uninstallTitle": "Paketi kaldır",
  "refinement-extensions.v2.retainExplanation": "Paket ve yetkiler kaldırılır. Yaşam alanlarınız, tablolarınız ve kayıtlarınız varsayılan olarak korunur.",
  "refinement-extensions.v2.archiveExplanation": "Paketin oluşturduğu alanlar ayrı bir imzalı önizlemeden sonra arşivlenir. Kayıtlar kurtarılabilir kalır; hiçbir şey sessizce kalıcı silinmez.",
  "refinement-extensions.v2.archiveData": "Paketin oluşturduğu alanları da arşivle",
  "refinement-extensions.v2.previewUninstall": "Kaldırmayı önizle",
  "refinement-extensions.v2.archiveConsent": "Listelenen paket alanlarının arşivlenmesini onaylıyorum.",
  "refinement-extensions.v2.uninstall": "Kaldır",
  "refinement-extensions.v2.surfaces.title": "Kurulu paket araçları",
  "refinement-extensions.v2.surfaces.description": "Bu güvenli çalışma alanı araçları etkin veri paketlerinden çözümlenir ve yalnızca yerleşik Yaşam yüzeylerini açar.",
  "refinement-extensions.v2.surfaces.error": "Kurulu paket araçları yüklenemedi.",
  "refinement-extensions.v2.surfaces.openTable": "Tabloyu aç",
  "refinement-extensions.v2.surfaces.openCards": "Kartları aç",
  "refinement-extensions.v2.surfaces.openTimeline": "Zaman çizelgesini aç",
  "refinement-extensions.v2.surfaces.capture": "Kayıt ekle",
  "refinement-extensions.v2.surfaces.renderer.record_table": "Kayıt tablosu",
  "refinement-extensions.v2.surfaces.renderer.quick_capture": "Hızlı kayıt",
  "refinement-extensions.v2.surfaces.renderer.summary_cards": "Özet kartları",
  "refinement-extensions.v2.surfaces.renderer.timeline": "Zaman çizelgesi"
}
